module.exports = __webpack_public_path__ + "img/gallery_5.a9577521.jpg";